import {
    SET_QRCODE_OBJECT,
    SET_VIDEO_URL,
    SET_CUSTOM_HTML,
    SET_CUSTOM_JS,
    RAISE_QRCODE_ERROR,
    CLEAR_ERROR,
    SET_CUSTOM_FULL_HTML,
    SET_WEBAR_URL,
    SET_AUDIO_URL,
    SET_CURRENT_PHOTOS
} from "./mutation-types";
import { QrcodeState } from "./state";

export default {
    [SET_QRCODE_OBJECT](state: QrcodeState, qrcodeObject) {
        state.qrcodeObject = { ...qrcodeObject };

        // compute logoB64
        if (state.qrcodeObject?.template.landingLogoDataurl?.length) {
            if (state.qrcodeObject.template.landingLogoDataurl.substr(0, 10) !== "data:image") {
                state.logoB64 =
                    "data:image/png;base64," + state.qrcodeObject.template.landingLogoDataurl;
            } else {
                state.logoB64 = state.qrcodeObject.template.landingLogoDataurl;
            }
        }
        state.isThankYouEmailAllowed = qrcodeObject.thankYouEmailAllowed;
        state.isThankYouEmailSent = qrcodeObject.thankYouEmailSent;
    },

    [SET_VIDEO_URL](state: QrcodeState, videoUrl: string) {
        state.videoUrl = videoUrl;
    },
    [SET_AUDIO_URL](state: QrcodeState, audioUrl: string) {
        state.audioUrl = audioUrl;
    },
    [SET_CURRENT_PHOTOS](state: QrcodeState, photos: string[]) {
        state.currentPhotos = photos;
    },

    [SET_CUSTOM_HTML](state: QrcodeState, customHtml: string) {
        state.customHtml = customHtml;
    },
    [SET_CUSTOM_FULL_HTML](state: QrcodeState, customHtml: string) {
        state.customFullHtml = customHtml;
    },

    [SET_CUSTOM_JS](state: QrcodeState, customJs: string[]) {
        state.customJs = [].concat(customJs);
    },

    [RAISE_QRCODE_ERROR](state: QrcodeState, content: { title: string; text: string, isBanned?: boolean} ) {
        state.error = { ...content };
        state.isBanned = content.isBanned;
    },

    [CLEAR_ERROR](state: QrcodeState) {
        state.error = {
            title: "",
            text: ""
        };
    },
    [SET_WEBAR_URL](state: QrcodeState, url: string){
        state.webarUrl = url;
    }
};
